import { CardConditionalHighlight, CardTitle } from "../common";
import React, { useImperativeHandle } from "react";

import PushSubscriptionButton from "../../helpers/PushNotificationToggle";
import { useParams } from "react-router-dom";

const NotificationCard = React.forwardRef(
  ({ card, topic, messages, w, h, displayVariant, displayParameters }, ref) => {
    const { token } = useParams();

    const action = (setSelectedCard) => {
      setSelectedCard(card);
    };

    useImperativeHandle(ref, () => ({ action }));

    const params = displayParameters || card.params || {};

    const renderContent = () => {
      return (
        <div className="flex flex-col items-center justify-around w-full h-full">
          <CardTitle title={topic.name} />

          <a className="h-10 w-content m-auto">
            <PushSubscriptionButton dashboardToken={token} cardId={card.id} />
          </a>
        </div>
      );
    };

    return (
      <CardConditionalHighlight card={card}>
        <div className="p-2 w-full h-full bg-ghost-white">
          {renderContent()}
        </div>
      </CardConditionalHighlight>
    );
  }
);

NotificationCard.variants = ["email", "sms", "push"];
NotificationCard.variantParameters = {
  email: {},
  sms: {},
  push: {
    title: {
      label: "Notification title",
      type: "string",
      default: "",
    },
    message: {
      label: "Message to send",
      type: "string",
      default: "",
    },
  },
};

export default NotificationCard;
